import { createApiHandler } from './handler';

const incomes = {
  apiClient: null,
  path: '/admin/incomes',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

};

export default incomes;
